export let photo_1_1 = {
	"name": "photo_1_1",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как меняется глубина резкости при уменьшении отверстия диафрагмы?",
				"correct_ans": [
					{
						"ans": "Глубина резкости увеличивается",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Глубина резкости уменьшается",
						"score": 0
					},
					{
						"ans": "Глубина резкости не изменяется",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Глубина резкости (или резко изображаемого пространства) прямо зависит от величины отверстия диафрагмы объектива. Чем меньше отверстие, тем выше глубина резкости. Диафрагмируя объектив, можно добиться того, что находящиеся на разном расстоянии от фотоаппарата предметы получатся одинаково резко. Но при этом не следует забывать, что уменьшая диафрагму, а, следовательно, и количество света, падающего на пленку, необходимо увеличивать выдержку, чтобы не изменилась экспозиция"
}

export let photo_1_2 = {
	"name": "photo_1_2",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Должна ли меняться экспозиция при съемке со светофильтром?",
				"correct_ans": [
					{
						"ans": "Должна увеличиваться",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Должна уменьшаться",
						"score": 0
					},
					{
						"ans": "Не должна изменяться",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Поскольку светофильтр поглощает часть проходящего через него света, это изменение экспозиции необходимо компенсировать либо увеличением отверстия диафрагмы, либо увеличением выдержки (в среднем - на одно деление)"
}

export let photo_1_3 = {
	"name": "photo_1_3",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какое сочетание выдержки и диафрагмы лучше использовать при ориентирующей съемке?",
				"correct_ans": [
					{
						"ans": "1/60 и 8",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "1/500 и 2,8",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При ориентирующей съемке, если, конечно, позволяют возможности фотоаппарата и чувствительность пленки, лучше пользоваться значениями диафрагмы в интервале от 5,6 до 11, чтобы получить достаточную глубину резкости"
}

export let photo_1_4 = {
	"name": "photo_1_4",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какую чувствительность для дневного света имеет пленка КН-2?",
				"correct_ans": [
					{
						"ans": "32 ед",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "11 ед",
						"score": 0
					},
					{
						"ans": "22 ед",
						"score": 0
					},
					{
						"ans": "65 ед",
						"score": 0
					},
					{
						"ans": "130 ед",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_5 = {
	"name": "photo_1_5",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как следует наматывать пленку на катушку в кассете?",
				"correct_ans": [
					{
						"ans": "Эмульсией внутрь",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Эмульсией наружу",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Только эмульсией вовнутрь. Тогда в фильмовом канале фотоаппарата пленка будет обращена эмульсией к идущему через объектив свету"
}

export let photo_1_6 = {
	"name": "photo_1_6",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как связаны между собой чувствительность пленки и ее зернистость?",
				"correct_ans": [
					{
						"ans": "Чем выше чувствительность, тем выше зернистость",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Чем выше чувствительность, тем меньше зернистость",
						"score": 0
					},
					{
						"ans": "Между чувствительностью и зернистостью связи нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_7 = {
	"name": "photo_1_7",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какие фотопленки имеют более высокую чувствительность?",
				"correct_ans": [
					{
						"ans": "Негативные",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Позитивные",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Более высокую чувствительность имеют негативные пленки, т.е. те, которые используются непосредственно для фотосъемки. Позитивные пленки предназначены для получения на них позитивного изображения контактным способом. Высокая чувствительность здесь не требуется. У позитивных пленок она составляет всего 1-2 ед"
}

export let photo_1_8 = {
	"name": "photo_1_8",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Каким объективом из перечисленных лучше воспользоваться для съемки удаленного объекта?",
				"correct_ans": [
					{
						"ans": "Юпитер-37 (f=135 мм)",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Мир-1 (f=37 мм)",
						"score": 0
					},
					{
						"ans": "Гелиос-44 (f=58 мм)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Удаленные объекты необходимо снимать объективами с большим фокусным расстоянием, чтобы на снимке получить достаточно крупное их изображение. Из перечисленных для такой цели следует взять объектив \"Юпитер-37\""
}

export let photo_1_9 = {
	"name": "photo_1_9",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "При какой съемке часто приходится пользоваться переходными кольцами?",
				"correct_ans": [
					{
						"ans": "При детальной",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "При узловой",
						"score": 0
					},
					{
						"ans": "При сигналетической",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "С помощью переходных колец, устанавливаемых между фотоаппаратом и объективом, можно получить очень крупное и четкое изображение очень небольшого предмета. Поэтому, переходными кольцами часто приходится пользоваться при детальной съемке, т.е. при съемке следов орудий взлома, пальцев рук, стреляных гильз и т.п"
}

export let photo_1_10 = {
	"name": "photo_1_10",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "С какой выдержкой следует фотографировать со вспышкой?",
				"correct_ans": [
					{
						"ans": "1/30",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "С выдержкой от руки",
						"score": 0
					},
					{
						"ans": "1/500",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При съемке с импульсной лампой-вспышкой необходимо, чтобы в момент ее срабатывания кадровое окно фотоаппарата было полностью открыто. У большинства фотоаппаратов со шторно-щелевыми затворами (Зенит) это достигается обычно при выдержке 1/30. Обычно выдержка для работы со вспышкой обозначается другим цветом, или символом \"30-Х\". У фотоаппаратов с центральным затвором со вспышкой можно снимать при любом значении выдержки"
}

export let photo_1_11 = {
	"name": "photo_1_11",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой объектив лучше использовать при ориентирующей съемке?",
				"correct_ans": [
					{
						"ans": "Короткофокусный",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Длиннофокусный",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При съемке короткофокусным объективом (или широкоугольником) в кадр попадает больше предметов и объектов из-за эффекта удаления. Поэтому, ориентирующую съемку лучше всего вести именно таким объективом, например, \"Мир-1\""
}

export let photo_1_12 = {
	"name": "photo_1_12",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какую светочувствительность имеет пленка Микрат-200?",
				"correct_ans": [
					{
						"ans": "5-10 ед",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "1-2 ед",
						"score": 0
					},
					{
						"ans": "32 ед",
						"score": 0
					},
					{
						"ans": "45 ед",
						"score": 0
					},
					{
						"ans": "200 ед",
						"score": 0
					},
					{
						"ans": "500 ед",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Специальная пленка Микрат-200 предназначена, в основном, для использования в репродукционных установках, в частности, для пересъемки документов, следов пальцев рук и т.п. Она имеет небольшую чувствительность в пределах 5-10 ед., ширину 35 мм и желтый цвет подложки. Обрабатывать ее можно даже при красном свете, как фотобумагу"
}

export let photo_1_13 = {
	"name": "photo_1_13",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какая фотопленка более мелкозернистая?",
				"correct_ans": [
					{
						"ans": "ФН-64",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "ФН-125",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Пленка ФН-64 имеет более мелкое зерно из-за более низкой светочувствительности. Зернистость и светочувствительность между собой связаны прямо пропорционально"
}

export let photo_1_14 = {
	"name": "photo_1_14",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как долго может храниться отснятая, но не проявленная черно-белая негативная пленка?",
				"correct_ans": [
					{
						"ans": "2-3 месяца",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "10-15 дней",
						"score": 0
					},
					{
						"ans": "До 1 года",
						"score": 0
					},
					{
						"ans": "Не более 3-х лет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Лучше всего отснятую пленку проявлять сразу. Это относится не только к черно-белым пленкам, но и к цветным. При длительном хранении происходит диффузия молекул светочувствительного слоя, вследствие чего после проявления резкость полученного изображения будет ниже. Если пленку сразу обработать нельзя, то хранить ее лучше всего в холодильнике. В этом случае влияние фактора времени будет заметно меньше"
}

export let photo_1_15 = {
	"name": "photo_1_15",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какое сочетание выдержки и диафрагмы лучше использовать при съемке движущегося объекта?",
				"correct_ans": [
					{
						"ans": "1/250 и 2,8",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "1/30 и 8",
						"score": 0
					},
					{
						"ans": "В и 16",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Чем быстрее движется объект, тем короче должна быть выдержка, иначе изображение будет смазанным. Чтобы не изменить экспозицию, уменьшая выдержку, следует одновременно увеличить отверстие диафрагмы"
}

export let photo_1_16 = {
	"name": "photo_1_16",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой цвет имеет подложка пленки Микрат-200?",
				"correct_ans": [
					{
						"ans": "Желтый",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Зеленый",
						"score": 0
					},
					{
						"ans": "Розовый",
						"score": 0
					},
					{
						"ans": "Серый",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Подложка пленки Микрат-200 имеет желтый цвет, Микрат-300 - зеленый"
}

export let photo_1_17 = {
	"name": "photo_1_17",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "При какой фотосъемке используется масштабная линейка?",
				"correct_ans": [
					{
						"ans": "При детальной",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "При ориентирующей",
						"score": 0
					},
					{
						"ans": "При обзорной",
						"score": 0
					},
					{
						"ans": "При узловой",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Масштабная линейка используется при детальной съемке. Она располагается рядом со снимаемым объектом и непременно должна попасть в кадр, чтобы в дальнейшем иметь возможность произвести необходимые измерения снятого объекта. Во время съемки плоскость линейки должна быть параллельна плоскости пленки в кадровом окне во избежание линейных искажений"
}

export let photo_1_18 = {
	"name": "photo_1_18",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Что означает буква У в названии объектива Индустар-22У ?",
				"correct_ans": [
					{
						"ans": "Для увеличителя",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Универсальный",
						"score": 0
					},
					{
						"ans": "Присоединительная резьба имеет увеличенный диаметр",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_19 = {
	"name": "photo_1_19",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Зависит ли выдержка от фокусного расстояния?",
				"correct_ans": [
					{
						"ans": "Не зависит",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Зависит прямо пропорционально",
						"score": 0
					},
					{
						"ans": "Зависит обратно пропорционально",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Практически, выдержка от фокусного расстояния не зависит. Лишь при съемке объективами с фокусным расстоянием 500 мм и больше, рекомендуется на одно деление увеличить отверстие диафрагмы или выдержку"
}

export let photo_1_20 = {
	"name": "photo_1_20",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как связаны между собой диафрагма и выдержка?",
				"correct_ans": [
					{
						"ans": "Обратно пропорционально",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Прямо пропорционально",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Связь здесь обратно пропорциональная. Чем больше выдержка, тем меньше должно быть отверстие диафрагмы и наоборот. Обеспечить требуемую экспозицию можно различными сочетаниями диафрагма-выдержка. Выбор того или иного сочетания должен определяться стоящей конкретной задачей"
}

export let photo_1_21 = {
	"name": "photo_1_21",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какая выдержка нужна при свете луны?",
				"correct_ans": [
					{
						"ans": "15-30 мин",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "1/30",
						"score": 0
					},
					{
						"ans": "15-30 сек",
						"score": 0
					},
					{
						"ans": "1,5-2 мин",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При свете луны выдержка, в зависимости от чувствительности используемой пленки, составляет уже десятки минут. Такая съемка производится только со штатива, на который крепится фотоаппарат, после чего на шкале выдержек устанавливается символ \"В\", т.е. выдержка от руки, и блокируется на необходимое время спусковая кнопка"
}

export let photo_1_22 = {
	"name": "photo_1_22",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как фотографировать в туман, ослабив при этом его действие?",
				"correct_ans": [
					{
						"ans": "Применить оранжевый светофильтр",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Использовать лампу-вспышку",
						"score": 0
					},
					{
						"ans": "Применить желто-зеленый светофильтр",
						"score": 0
					},
					{
						"ans": "Максимально задиафрагмировать объектив",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_23 = {
	"name": "photo_1_23",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как лучше всего избежать запотевания объектива в теплом помещении с высокой влажностью (баня, бассейн и т.п.)?",
				"correct_ans": [
					{
						"ans": "Не открывая фотоаппарата, дать ему согреться",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Вести съемку с бесцветным светофильтром",
						"score": 0
					},
					{
						"ans": "Вести съемку, поместив фотоаппарат в прозрачный полиэтиленовый мешок",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_24 = {
	"name": "photo_1_24",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Вредно ли оставлять затвор фотоаппарата взведенным?",
				"correct_ans": [
					{
						"ans": "Да, при этом ослабевает пружина",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Практически нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_25 = {
	"name": "photo_1_25",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как в общем случае выполняется съемка лиц для уголовно-регистрационных снимков?",
				"correct_ans": [
					{
						"ans": "В фас и правый профиль",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "В фас",
						"score": 0
					},
					{
						"ans": "В фас и правый полупрофиль",
						"score": 0
					},
					{
						"ans": "В фас и левый профиль",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_26 = {
	"name": "photo_1_26",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как делаются снимки, предъявляемые для опознания лиц?",
				"correct_ans": [
					{
						"ans": "В фас, оба профиля и 3/4 поворота головы",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "В фас",
						"score": 0
					},
					{
						"ans": "В фас и правый профиль",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_27 = {
	"name": "photo_1_27",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Где должен располагаться фотоаппарат при съемке в полный рост?",
				"correct_ans": [
					{
						"ans": "На уровне пояса",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "На уровне груди",
						"score": 0
					},
					{
						"ans": "На уровне подбородка",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_28 = {
	"name": "photo_1_28",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Где должен располагаться фотоаппарат при съемке по пояс?",
				"correct_ans": [
					{
						"ans": "На уровне подбородка",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "На уровне груди",
						"score": 0
					},
					{
						"ans": "На уровне глаз",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_29 = {
	"name": "photo_1_29",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Где должен располагаться фотоаппарат при портретной съемке?",
				"correct_ans": [
					{
						"ans": "На уровне глаз",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "На уровне подбородка",
						"score": 0
					},
					{
						"ans": "На уровне губ",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_30 = {
	"name": "photo_1_30",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как следует производить фотосъемку при предъявлении группы лиц для опознания?",
				"correct_ans": [
					{
						"ans": "Всю группу целиком, затем опознанное лицо в фас и профиль",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Всю группу целиком, затем опознанное лицо во весь рост",
						"score": 0
					},
					{
						"ans": "Опознанное лицо в правый полупрофиль и в полный рост",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_31 = {
	"name": "photo_1_31",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как лучше всего фотографировать объект, имеющий значительную протяженность (поезд, берег реки и т.п.)?",
				"correct_ans": [
					{
						"ans": "Использовать метод панорамной съемки",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Применить широкоугольный объектив",
						"score": 0
					},
					{
						"ans": "Использовать широкоформатный фотоаппарат",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Широкоугольный объектив и панорамный фотоаппарат (Горизонт) здесь помогут далеко не всегда. При съемке протяженных объектов используется метод панорамной съемки, суть которого состоит в том, что делается несколько последовательных снимков объекта, которые после печати стыкуются в единое целое. Различают метод круговой панорамной съемки и линейной. В первом случае все снимки делаются с одной точки с поворотом фотоаппарата. Во втором - фотоаппарат перемещается параллельно снимаемому объекту. Так, методом линейной панорамы удобно снимать дорожку следов ног, следы транспортного средства и т.п"
}

export let photo_1_32 = {
	"name": "photo_1_32",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "С каким светофильтром следует фотографировать желтый рисунок на белой бумаге?",
				"correct_ans": [
					{
						"ans": "С голубым",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "С желтым",
						"score": 0
					},
					{
						"ans": "С оранжевым",
						"score": 0
					},
					{
						"ans": "С поляризационным",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "С желтым и оранжевым светофильтром Вы никакой рисунок вообще не увидите. Задача состоит в том, чтобы его выделить, сделать максимально контрастным. С этой целью и используется голубой светофильтр"
}

export let photo_1_33 = {
	"name": "photo_1_33",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "С каким светофильтром целесообразно производить съемку зимой?",
				"correct_ans": [
					{
						"ans": "С желтым или оранжевым",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "С фиолетовым",
						"score": 0
					},
					{
						"ans": "С поляризационным",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_34 = {
	"name": "photo_1_34",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как следует освещать при съемке потожировые следы рук на глянцевой поверхности?",
				"correct_ans": [
					{
						"ans": "Косопадающим (под 45 град.) узким пучком света",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Лампой-вспышкой под 90 град",
						"score": 0
					},
					{
						"ans": "Двумя источниками света под углом 5-20 град",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_35 = {
	"name": "photo_1_35",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как следует освещать при съемке объемные следы пальцев?",
				"correct_ans": [
					{
						"ans": "Источником света под 5-20 град",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Двумя источниками света под 60 град",
						"score": 0
					},
					{
						"ans": "Лампой-вспышкой под 90 град. и белым экраном",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При использовании источника света, расположенного под небольшим углом, порядка 5-20 град., удается добиться хорошего контраста объемных следов пальцев рук и получить их качественные снимки"
}

export let photo_1_36 = {
	"name": "photo_1_36",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как правильно сфотографировать дорожку следов на участке значительной протяженности?",
				"correct_ans": [
					{
						"ans": "Панорамным способом",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Широкоугольным объективом с низкой точки съемки всю дорожку вдоль",
						"score": 0
					},
					{
						"ans": "Каждый след в отдельности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Для съемки протяженной дорожки следов необходимо воспользоваться методом линейной панорамы"
}

export let photo_1_37 = {
	"name": "photo_1_37",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как рекомендуется фотографировать следы на снегу?",
				"correct_ans": [
					{
						"ans": "При боковом освещении с желтым или оранжевым светофильтром",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "При фронтальном освещении с ультрафиолетовым светофильтром",
						"score": 0
					},
					{
						"ans": "Со вспышкой максимально диафрагмируя объектив",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Здесь действует тот же принцип, что и при съемке объемных следов пальцев рук. Применение желтого или оранжевого светофильтров, позволяет значительно повысить контраст готовых снимков"
}

export let photo_1_38 = {
	"name": "photo_1_38",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как производится фотографирование трупа для его последующего опознания?",
				"correct_ans": [
					{
						"ans": "В фас, оба профиля, 3/4 поворота головы плюс фото частей тела с характерными приметами",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "В фас и правый профиль",
						"score": 0
					},
					{
						"ans": "Во весь рост с верхней точки съемки и крупно в фас",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_39 = {
	"name": "photo_1_39",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как производится фотографирование висящих трупов?",
				"correct_ans": [
					{
						"ans": "Спереди, сзади и с боков",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Спереди и справа",
						"score": 0
					},
					{
						"ans": "Спереди и сзади",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let photo_1_40 = {
	"name": "photo_1_40",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Как следует фотографировать пробоины (например, пулевые) в стекле?",
				"correct_ans": [
					{
						"ans": "Против света",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "На темном фоне",
						"score": 0
					},
					{
						"ans": "С подсветкой под 45 град",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Лучшие результаты дает фотографирование пробоин в стекле против света"
}

export let photo_1_41 = {
	"name": "photo_1_41",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какую воду лучше всего использовать для приготовления проявляющих растворов?",
				"correct_ans": [
					{
						"ans": "Дистиллированную",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Родниковую",
						"score": 0
					},
					{
						"ans": "Водопроводную кипяченую",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вода для приготовления проявляющих растворов должна быть чистой и не содержать солей. В идеале - это дистиллированная вода. Можно также использовать водопроводную воду, но только после кипячения, или добавлять специальные водоумягчители, например, трилон-Б. Родниковая вода обладает большой жесткостью из-за высокой концентрации растворенных в ней солей, и поэтому непригодна"
}

export let photo_1_42 = {
	"name": "photo_1_42",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какова нормальная температура фотографических растворов?",
				"correct_ans": [
					{
						"ans": "18-20 град",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "11-12 град",
						"score": 0
					},
					{
						"ans": "23-25 град",
						"score": 0
					},
					{
						"ans": "30-32 град",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Нормальная температура проявителя составляет 18-20 град. При изменении температуры изменяется и скорость проявления, что заставляет вносить соответствующие коррективы и изменять время проявления. При увеличении температуры скорость проявления увеличивается и наоборот"
}

export let photo_1_43 = {
	"name": "photo_1_43",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Что произойдет при увеличении температуры проявляющего раствора при обработке пленок?",
				"correct_ans": [
					{
						"ans": "Увеличится скорость проявления",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "На негативе появится вуаль",
						"score": 0
					},
					{
						"ans": "Уменьшится резкость изображения",
						"score": 0
					},
					{
						"ans": "Уменьшится скорость проявления",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вследствие увеличения скорости работы проявителя, при неизменном времени проявления, негатив получится более плотным и, скорей всего, он будет иметь также повышенную зернистость"
}

export let photo_1_44 = {
	"name": "photo_1_44",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Чему равно среднее время проявления черно-белых негативных фотопленок?",
				"correct_ans": [
					{
						"ans": "6-8 мин",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "0,5-1 мин",
						"score": 0
					},
					{
						"ans": "2-3 мин",
						"score": 0
					},
					{
						"ans": "15-18 мин",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В среднем это 6-8 минут при температуре проявителя 18-20 град. Время проявления указывается на упаковке пленки, однако, относится оно к стандартному проявителю N 2. При обработке пленки другими проявителями это время может незначительно отличаться от указанного"
}

export let photo_1_45 = {
	"name": "photo_1_45",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "В каком ответе правильно перечислены компоненты мелкозернистого проявителя?",
				"correct_ans": [
					{
						"ans": "Метол, сульфит натрия, сода, бромистый калий",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Метол, гидрохинон, поташ, метабисульфит калия",
						"score": 0
					},
					{
						"ans": "Фенидон, сернокислый натрий, сода, роданистый калий",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В состав пленочного мелкозернистого стандартного проявителя (N2) входят: метол (проявляющее вещество), сульфит натрия (противоокислительное вещество), сода (ускоряющее вещество) и бромистый калий (противовуалирующее вещество). Метабисульфит калия, роданистый калий и сернокислый натрий в состав проявителя для черно-белых пленок не входят"
}

export let photo_1_46 = {
	"name": "photo_1_46",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Назовите основной компонент фиксирующего раствора",
				"correct_ans": [
					{
						"ans": "Тиосульфат натрия",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Метабисульфит калия",
						"score": 0
					},
					{
						"ans": "Сульфит натрия",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Основным компонентом фиксирующего раствора является тиосульфат натрия (бывает кристаллический и безводный), который известен больше под названием гипосульфит"
}

export let photo_1_47 = {
	"name": "photo_1_47",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Чему равна средняя продолжительность фиксирования черно-белых фотоматериалов?",
				"correct_ans": [
					{
						"ans": "15-20 мин",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "2-3 мин",
						"score": 0
					},
					{
						"ans": "6-8 мин",
						"score": 0
					},
					{
						"ans": "40-60 мин",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Нормальное время фиксирования черно-белых фотопленок и фотобумаг составляет 15-20 мин. в свежих растворах. В этом случае готовые фотоматериалы будут храниться очень долго. К недофиксированию особенно чувствительна фотобумага"
}

export let photo_1_48 = {
	"name": "photo_1_48",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Нужно ли хранить фотографические растворы в холодильнике?",
				"correct_ans": [
					{
						"ans": "Нет, в растворах может выпасть осадок",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Весьма желательно",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Не только не нужно, но даже вредно, т.к. возможно выпадение осадка. Растворы следует хранить в плотно закрытых и заполненных под горловину банках из темного стекла при комнатной температуре. Неработавшие проявитель и фиксаж могут так храниться месяц и более"
}

export let photo_1_49 = {
	"name": "photo_1_49",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какие обрабатывающие растворы окисляются быстрее?",
				"correct_ans": [
					{
						"ans": "Бывшие в употреблении",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Свежеприготовленные, но не работавшие",
						"score": 0
					},
					{
						"ans": "Скорость окисления у них примерно одинакова",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Срок сохранности проявителя, которым даже очень мало пользовались, исчисляется всего несколькими днями. В отличие от свежеприготовленного, он окисляется на порядок быстрее"
}

export let photo_1_50 = {
	"name": "photo_1_50",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Чему равно среднее время окончательной промывки фотоматериалов в проточной воде?",
				"correct_ans": [
					{
						"ans": "15-30 мин",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "2-3 мин",
						"score": 0
					},
					{
						"ans": "6-8 мин",
						"score": 0
					},
					{
						"ans": "40-60 мин",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Это время должно быть не менее 15-30 минут, чтобы полностью вымыть остатки фиксирующего раствора из эмульсионного слоя и подложки фотоматериала. Плохо промытый фотоотпечаток вскоре начинает желтеть"
}

export let photo_1_51 = {
	"name": "photo_1_51",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Можно ли для промывки фотопленки использовать морскую воду?",
				"correct_ans": [
					{
						"ans": "Можно",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Нельзя",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Морскую воду для промывки фотоматериалов можно использовать совершенно безболезненно. Но только для промывки, а не для приготовления растворов!"
}

export let photo_1_52 = {
	"name": "photo_1_52",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "К чему может привести недостаточная промывка фотоотпечатков?",
				"correct_ans": [
					{
						"ans": "К их пожелтению в дальнейшем",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "К появлению вуали",
						"score": 0
					},
					{
						"ans": "К порче рабочей поверхности электро-глянцевателя",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Плохо промытый фотоотпечаток со временем начинает желтеть и оказывается безвозвратно испорченным"
}

export let photo_1_53 = {
	"name": "photo_1_53",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Чем отличается обработка 35-мм черно-белых негативных пленок от обработки 60-мм?",
				"correct_ans": [
					{
						"ans": "Ничем",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Большей продолжительностью проявления",
						"score": 0
					},
					{
						"ans": "Рецептурой растворов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Эти пленки друг от друга отличаются только длиной, шириной и перфорацией. Эмульсионный слой у них одинаковый, а, следовательно, одинаковой будет и их экспозиция и обработка"
}

export let photo_1_54 = {
	"name": "photo_1_54",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Можно ли проявлять пленку ФН-64 при красном свете?",
				"correct_ans": [
					{
						"ans": "Нельзя",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Можно",
						"score": 0
					},
					{
						"ans": "Можно при использовании темно-красного светофильтра в фонаре",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Черно-белые негативные фотопленки должны проявляться в полной темноте. Лишь после 3-5 минут фиксирования можно открыть бачок и дальнейшую обработку вести при слабом свете"
}

export let photo_1_55 = {
	"name": "photo_1_55",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "При каком освещении следует проявлять пленку МИКРАТ-300?",
				"correct_ans": [
					{
						"ans": "В полной темноте",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "При слабом красном свете",
						"score": 0
					},
					{
						"ans": "При оранжевом свете",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Пленку Микрат-300, в отличие от Микрат-200, необходимо проявлять в полной темноте"
}

export let photo_1_56 = {
	"name": "photo_1_56",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Что произойдет, если проявлять пленку МИКРАТ-200 при красном свете?",
				"correct_ans": [
					{
						"ans": "Ничего",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Пленка окажется засвеченной",
						"score": 0
					},
					{
						"ans": "Появится вуаль",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вот эту пленку можно проявлять при слабом красном свете, как и фотобумагу"
}

export let photo_1_57 = {
	"name": "photo_1_57",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Каким проявителем следует обрабатывать пленку МИКРАТ-200?",
				"correct_ans": [
					{
						"ans": "УП-2",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Мелкозернистым МП-1",
						"score": 0
					},
					{
						"ans": "Стандартным N 2",
						"score": 0
					},
					{
						"ans": "Амидоловым, разбавленным в соотношении 1:2",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Эту пленку можно проявлять в проявителе для фотобумаги или в фенидон-гидрохиноновом"
}

export let photo_1_58 = {
	"name": "photo_1_58",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Можно ли в увеличителе при печати использовать объектив от фотоаппарата?",
				"correct_ans": [
					{
						"ans": "Можно",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Можно, но при этом ухудшится резкость",
						"score": 0
					},
					{
						"ans": "Нельзя",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Это делать можно, но не следует забывать, что многие современные объективы не рассчитаны на воздействие высокой температуры, которую создает лампа увеличителя"
}

export let photo_1_59 = {
	"name": "photo_1_59",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Должна ли изменяться выдержка при печати с увеличением формата снимка?",
				"correct_ans": [
					{
						"ans": "Должна увеличиваться",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "Должна уменьшаться",
						"score": 0
					},
					{
						"ans": "Выдержка при этом не меняется",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При увеличении формата снимка уменьшается его освещенность. Поэтому выдержка обязательно должна увеличиваться. Поскольку освещенность обратно пропорциональна квадрату расстояния, то при увеличении расстояния от объектива до поверхности фотобумаги в два раза, выдержка должна увеличиваться примерно в четыре раза"
}

export let photo_1_60 = {
	"name": "photo_1_60",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "В каком масштабе печатаются регистрационные снимки?",
				"correct_ans": [
					{
						"ans": "1:7",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "1:5",
						"score": 0
					},
					{
						"ans": "1:10",
						"score": 0
					},
					{
						"ans": "1:14",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "На регистрационных снимках расстояние между зрачками составляет 10 мм. Это соответствует установленному масштабу 1:7, поскольку расстояние между зрачками у взрослого человека около 70 мм"
}

export let photo_1_61 = {
	"name": "photo_1_61",
	"descriprion": "type2",
	"theme": "Судебная фотография",
	"title": "Судебная фотография",
	"data": {
		"questions": [
			{
				"qst": "Какое расстояние между зрачками должно быть на регистрационном снимке?",
				"correct_ans": [
					{
						"ans": "1 10 мм",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "7 мм",
						"score": 0
					},
					{
						"ans": "1 12 мм",
						"score": 0
					},
					{
						"ans": "1 15 мм",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Это расстояние на регистрационном снимке должно быть равно 10 мм, что соответствует требуемому масштабу 1:7"
}

